<template>
                  <div class="p-2">
  <div class="card" style="width: 100%;">
  <!--<img class="card-img-top" data-src=".../100px180/" alt="Card image cap"> -->
  <div class="card-body">
    <h4 class="card-title">Cloud Solutions</h4>
    <p class="card-text"></p>
                <ul class="list-unstyled p-2 card-text">
                  <li class="p-1">
                    <router-link to="/solutions/cloud" >Overview</router-link>
                  </li>
                  <li class="p-1">
                    <router-link to="/solutions/cloud/datacentermodernization">Data Center Modernization</router-link>
                  </li>
                  <li class="p-1">
                    <router-link to="/solutions/cloud/hybridclouds">Hybrid Clouds</router-link>
                  </li>

                   <li class="p-1">
                    <router-link to="/solutions/cloud/devops">DevOps</router-link>
                  </li>
                </ul>
  </div>
</div>
              </div>
</template>

<script>
export default {
    name :'digitalInfrasidenav',
     mounted: function()
  {
    // From testing, without a brief timeout, it won't work.
    setTimeout(
      () => 
      {this.scrollFix(this.$route.hash) 
    
    }
    , 1);

  },
  methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang ;
    }
  }
}
</script>